import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateTemplatesMutation, UpdateTemplatesMutationVariables } from '@/graphql/generated/graphql';
import { UpdateTemplatesDocument } from '@/graphql/generated/graphql';
export type TemplateUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  Slug?: string
  Title?: string
  Description?: string
  Icon?: string
  Available?: boolean
  Popular?: boolean
  Href?: string
  EstimatedMinutes?: number
  SystemPrompt?: string
  SystemPromptRole?: string
  UilmDescriptionKey?: string
  UilmTitleKey?: string
  PreviewToken?: string
  Keywords?: string[]
  Category?: string
  Kind?: string
}

export type UpdateTemplateResponse = {
  data: {
    updateTemplates: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateTemplate = () => {
  const mutation = useMutation({
    mutationKey: ['update-template'],
    mutationFn: (variables: TemplateUpdateInput) => {
      return graphqlClient.request<UpdateTemplatesMutation>(UpdateTemplatesDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateTemplate: mutation.mutate,
    updateTemplateAsync: mutation.mutateAsync,
  }
}

export const UPDATE_TEMPLATE_MUTATION = UpdateTemplatesDocument;
